import { piOhDeepMerge } from "@/utils/object.helper";
/**
 * 饼图 -  configData 配置对象   div
 *
 configData ： {
  picType: '',  // 'full' : 高度占满 ，宽度和高度一致,左边图表，右边 legend
  legendValue : false, // legend 是否带 value
  legendProportion : false, // legend 是否带 百分比
 }
 */
export const getPicData = (configData, optionData, div) => {
    const posData = getPicPos(configData, optionData, div);
    const title = getTitle(configData, optionData, posData);
    const legend = getLegend(configData, optionData, posData);
    const series = getSeries(configData, optionData, posData);
    const grid = getGrid(configData, optionData);
    const option = {
        title: title,
        tooltip: {
            trigger: "item",
            formatter: "{b}: {c} ({d}%)",
        },
        legend: legend,
        color: optionData.color || [
            "#FFDC84",
            "#53C1FF",
            "#DE672F",
            "#F7B6B2",
            "#D9DADC",
            "#7AE795",
            "#4D80B7",
            "#18CFDB",
        ],
        grid: grid,
        series: series,
    };
    return option;
};
/**
 * 获取饼图位置
 * picType: '',  // 'full' : 高度占满 ，宽度和高度一致,左边图表，右边 legend
 * @param div
 * @returns
 */
const getPicPos = (configData, optionData, div) => {
    if (configData.picType == "full") {
        const height = div.offsetHeight;
        const centerLeft = height ? height / 2 + 16 : "12%"; // 饼图圆默认的在最左边，有16的边距
        const centerTop = "50%";
        const titleLeft = height / 2 + 12; // 标题在饼图圆中间，字大小 12
        const titleTop = height / 2 - 12; // 默认的最左边的圆中间
        const legendLeft = height + 16 + 32; // legend 位置在最左边的圆过来一点 16 左边距  32 圆和 legend 的边距
        return {
            centerLeft: centerLeft,
            centerTop: centerTop,
            legendLeft: legendLeft,
            legendTop: "center",
            titleLeft: titleLeft,
            titleTop: titleTop,
        };
    }
    else {
        return {
            centerLeft: "20%",
            centerTop: "50%",
            legendLeft: "50%",
            legendTop: 0,
            titleLeft: "18%",
            titleTop: "center",
        };
    }
};
/**
 * 获取标题对象, 主要是标题的位置 和 是否有副标题 ， 合并外面传进来的
 * @param configData
 * @param optionData
 * @param posData
 * @returns
 */
const getTitle = (configData, optionData, posData) => {
    const text = optionData.title && optionData.title.text ? optionData.title.text : "text";
    let title = {
        text: text,
        zlevel: 0,
        top: posData.titleTop,
        left: posData.titleLeft,
        textAlign: "center",
        textStyle: {
            color: "#101A25",
            fontSize: 12,
            lineHeight: 20,
        },
    };
    // 如果有副标题
    if (optionData.title &&
        optionData.title.subtext &&
        optionData.series &&
        optionData.series[0]) {
        // 有副标题就把总数变成标题，文字变成副标题
        let total = 0;
        const list = optionData.series[0].data || [];
        list.map((item) => {
            total += item.value;
        });
        title.text = parseFloat(total.toFixed(2));
        title.textStyle.fontSize = 24;
        title.textStyle.lineHeight = 32;
        title.textStyle.fontFamily = "BebasNeue";
        title.textStyle.fontWeight = "normal";
        title.subtext = optionData.title.subtext;
        title.itemGap = 0;
        title.top = "25%";
        title.subtextStyle = {
            fontSize: "12",
            align: "center",
            color: "#101A25",
            lineHeight: 20,
        };
        title = piOhDeepMerge(title, optionData.title);
    }
    else if (optionData.title) {
        title = piOhDeepMerge(title, optionData.title);
    }
    return title;
};
/**
 * 获取 Legend, 主要是位置 ， 合并外面传进来的
 * @param configData
 * @param optionData
 * @param posData
 * @returns
 */
const getLegend = (configData, optionData, posData) => {
    const nameWidth = 72; // 名称长度
    let legend = {
        orient: "vertical",
        left: posData.legendLeft,
        top: posData.legendTop,
        itemWidth: 6,
        itemHeight: 6,
        itemGap: 6,
        icon: "circle",
        formatter: ["{a|{name}}"].join("\n"),
        textStyle: {
            color: "#666",
            fontSize: 12,
            lineHeight: 20,
            rich: {
                //这里定义a的样式
                a: {
                    width: nameWidth,
                },
            },
        },
    };
    if (optionData.legend) {
        legend = piOhDeepMerge(legend, optionData.legend);
    }
    //legend 后面加上 value 或者 百分比
    if (configData.legendValue || configData.legendProportion) {
        legend.formatter = (name) => {
            let value = 0;
            let total = 0;
            const list = optionData.series[0].data || [];
            list.map((item) => {
                const itemValue = item.value || 0;
                if (item.name == name) {
                    value = itemValue;
                }
                total += itemValue;
            });
            let text = name;
            if (configData.legendValue) {
                text = text + " " + value;
            }
            // value 后面再加上 百分比
            if (configData.legendProportion) {
                const proportion = total > 0 ? ((value / total) * 100).toFixed(2) + "%" : "0%";
                text = text + " " + proportion;
            }
            return ["{a|" + text + "}"].join("\n");
        };
        legend.width = nameWidth;
        legend.backgroundColor = "transparent";
    }
    return legend;
};
/**
 * 获取 Series 主要是 center 位置 ， 合并外面传进来的
 * @param configData
 * @param optionData
 * @param posData
 * @returns
 */
const getSeries = (configData, optionData, posData) => {
    let radius = ["60%", "80%"];
    if (configData.picType == "full") {
        radius = ["78%", "100%"];
    }
    let series = {
        type: "pie",
        radius: radius,
        center: [posData.centerLeft, posData.centerTop],
        avoidLabelOverlap: false,
        label: {
            show: false,
            position: "center",
        },
        emphasis: {
            label: {
                show: false,
            },
        },
        labelLine: {
            show: false,
        },
        data: [],
        itemStyle: {
            borderRadius: 0,
            borderColor: "#fff",
            borderwidth: 5,
        },
        hoverAnimation: false,
    };
    if (optionData.series && optionData.series[0]) {
        if (optionData.series[0].data) {
            // 大于0的数量,  如果只有一个数据有数量，间隔之间的白色边边就没有存在的必要
            const maxZoreLength = optionData.series[0].data.filter((item) => {
                return item.value > 0;
            });
            if (maxZoreLength.length == 1) {
                series.itemStyle = {};
            }
        }
        series = piOhDeepMerge(series, optionData.series[0]);
    }
    return [series];
};
const getGrid = (configData, optionData) => {
    let grid = {};
    if (optionData.grid) {
        grid = piOhDeepMerge(grid, optionData.grid);
    }
    return grid;
};
